import { get } from 'lodash';

import FilterDefinition from 'helpers/search_filters/filter_definition';
import CurrencyFormatter from '../../search_filters/formatters/currency_formatter';
import PercentageFormatter from 'helpers/search_filters/formatters/percentage_formatter';

const buildSelector = path => query => get(query, `saleFilter.${path}`);

export const capRate = new FilterDefinition({
  label: 'Cap Rate',
  formatter: new PercentageFormatter({ maximumFractionDigits: 2 }),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minCapRate'),
  maxValue: buildSelector('maxCapRate')
});

export const salesDate = new FilterDefinition({
  label: 'Sale Date',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minSalesDate'),
  maxValue: buildSelector('maxSalesDate')
});

export const salesPrice = new FilterDefinition({
  label: 'Sale Price',
  formatter: new CurrencyFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minSalesPrice'),
  maxValue: buildSelector('maxSalesPrice')
});

export const sfPrice = new FilterDefinition({
  label: 'Price/SF',
  formatter: new CurrencyFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minSfPrice'),
  maxValue: buildSelector('maxSfPrice')
});

export default [capRate, salesDate, salesPrice, sfPrice];
